export default "__VITE_ASSET__6d78b50b__"